import get from 'lodash.get';
import { config } from '@yola/ws-sdk';
import getIsB2C from './is-b2c';

const getHelpCenterUrl = (rootState) => {
  const cfg = config.selectors.getConfig(rootState);

  if (getIsB2C(rootState)) {
    return get(cfg, 'common.ws-helpcenter.url');
  }

  return get(cfg, 'common.ws-helpcenter.wl_url');
};

export default getHelpCenterUrl;
